export default {
  baseUrlMicrofrontend:'https://app.demo-auth.surepoint.cloud',
  ssoApiBaseUrl:'https://apiv2.demo-auth.surepoint.cloud',
  addInDomainUrl: "",
};

export const env_name = "demo" 